<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header">
          <i class="fa fa-language"></i> Languages
        </div>
        <div class="card-body">
          <div class="mb-3">
            <button class="btn btn-sm btn-primary" type="button" (click)="onClickAdd()" tooltip="Add language" placement="top">
              <i class="fa fa-plus"></i> Add Language
            </button>
          </div>
          <table class="table table-responsive-sm table-hover table-outline mb-0">
            <thead class="thead-light">
              <tr>
                <th>#</th>
                <th>Language ISO</th>
                <th>Revision</th>
                <th>Status</th>
                <th>Is Active</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              @for (language of languages; track language.languageId; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ language.languageIso }}</td>
                  <td>{{ language.revision }}</td>
                  <td>
                    @if (language.translationsMissingCount > 0) {
                      <span class="badge bg-danger">{{ language.translationsMissingCount }} missing keys</span>
                    }
                  </td>
                  <td>
                    <div class="form-check form-switch">
                      <input class="form-check-input" type="checkbox" [checked]="language.isActive" (change)="onClickToggleActive(language)">
                    </div>
                  </td>
                  <td>
                    <div class="btn-group me-1">
                      <button class="btn btn-sm btn-primary" type="button" routerLink="/backoffice/configuration/language-translations" [queryParams]="{ id: language.languageId }" tooltip="Translations" placement="top"><i class="fa fa-list"></i></button>
                      <button class="btn btn-sm btn-warning" type="button" (click)="onClickEdit(language)" tooltip="Edit" placement="top"><i class="fa fa-edit"></i></button>
                    </div>
                    |
                    <button class="btn btn-sm btn-danger" type="button" (click)="onClickDelete(language)" tooltip="Delete" placement="top"><i class="fa fa-trash"></i></button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<app-language-add-modal #addModal></app-language-add-modal>
<app-language-edit-modal #editModal></app-language-edit-modal>
